exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-node-if-else[data-v-57648ff6]{padding:.75rem;outline:2px solid rgba(var(--fts-block-condition-background-rgb),.3)}", ""]);

// exports
